import React from 'react'
import { connect } from 'react-redux'

import GreyBig from './../GreyBig'
import CurrentHome from './CurrentHome'
import Item from './Item'
import GenericIcon from 'components/GenericIcon'

import {
  getLoanApplication,
} from 'containers/LoanApplication/reducers'
import {availableExpenses} from '../../Expenses/available-expenses'

class Expenses extends React.Component {
  sumExpenses(expenseType) {
    const { expenses } = this.props

    return Object.keys(expenseType)
      .map(key => expenses[key] || 0)
      .reduce((acc, value) => acc + value, 0)
  }

  render() {
    const {
      needsCurrentHome,
      expenses,
      expenses: {
        maritalStatusLabel,
        dependantsLabel,
        fixedRent,
        fixedEducation,
        fixedChildSupport,
        fixedFinance,
      },
      onGoToClick,
    } = this.props

    const housingExpense = this.sumExpenses(availableExpenses.housing_expenses)
    const personalExpenses = this.sumExpenses(availableExpenses.personal_expenses)
    const insuranceExpenses = this.sumExpenses(availableExpenses.insurance_expenses)

    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <a className='smaller' href='#' onClick={ () => onGoToClick('expenses')}>Edit</a>
          </div>
          Your monthly expenses
        </div>
        <div className='card-body'>
          { needsCurrentHome &&
            <CurrentHome
              expenses={ expenses }
            />
          }
          <GreyBig size='4' grey='Martial status' big={ maritalStatusLabel }/>
          <GreyBig size='4' grey='Dependants' big={ dependantsLabel }/>
          { housingExpense > 0 &&
            <Item
              title='Housing expenses'
              amount={ housingExpense }
            />
          }
          { personalExpenses > 0 &&
            <Item
              title='Personal expenses'
              amount={ personalExpenses }
            />
          }
          { insuranceExpenses > 0 &&
            <Item
              title='Insurance and other expenses'
              amount={ insuranceExpenses }
            />
          }
          <Item
            title='Total expenses'
            amount={ housingExpense + personalExpenses + insuranceExpenses }
          />
          { this.props.creditSenseEnabled &&
            <div>
              <hr/>
              <div className='justify-content-between d-sm-flex'>
                <b>Verified by Credit Sense</b>
                <div className='align-self-center d-none d-sm-block'>
                  <GenericIcon name='creditSense' />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  expenses: state.review.expenses,
  creditSenseEnabled: state.loanApplicationUser.creditSenseEnabled,
  needsCurrentHome: getLoanApplication(state).needsCurrentHome,
})

export default connect(mapStateToProps)(Expenses)
